import React from 'react';
import { IContentPanel } from './interfaces';
import { Box, Typography } from '@mui/material';
import { BORDER_COLOR } from '../../constants';

export const ContentPanel: React.FC<IContentPanel> = ({
  children,
  title,
  sx,
  marginTop = false,
  isSubPanel = false,
  borderRadius = 'all',
}): JSX.Element => {
  const borderRadiusValue = (() => {
    if (borderRadius === 'all') {
      return '5px';
    } else if (borderRadius === 'left') {
      return '5px 0 0 5px';
    } else if (borderRadius === 'right') {
      return '0 5px 5px 0';
    } else if (borderRadius === 'top') {
      return '5px 5px 0 0';
    } else if (borderRadius === 'bottom') {
      return '0 0 5px 5px';
    }

    return null;
  })();

  const marginTopValue = (() => {
    if (!marginTop) {
      return '0';
    } else if (marginTop === 'small') {
      return '10px';
    }

    return '15px';
  })();

  return (
    <Box
      sx={{
        mt: marginTopValue,
      }}
    >
      {title && (
        <Typography
          component="h2"
          fontSize={isSubPanel ? '1rem' : '1.2rem'}
          fontWeight="bold"
          color="text.primary"
        >
          {title}
        </Typography>
      )}
      <Box
        component="main"
        sx={{
          p: '15px',
          backgroundColor: '#FFF',
          border: `.5px solid ${BORDER_COLOR}`,
          borderRadius: borderRadiusValue,
          ...sx,
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
